import { announcementManager } from "@core/service-container";
import { sendAnnouncementDisplayEvent } from "@domain/announcement/announcement-analytics";
import { useUser } from "@domain/user/hooks/use-user";
import { DialogContext, ModalId } from "@ui/components/dialog/dialog-provider";
import { isNil } from "@utils/assert";
import { useObservable } from "micro-observables";
import React, { useContext, useEffect } from "react";

export const AnnouncementHandler: React.FC = () => {
	const dialogContext = useContext(DialogContext);
	const announcement = useObservable(announcementManager.announcement);
	const user = useUser();

	useEffect(() => {
		if (!user?.hasAgreedToLegalDocuments) return;
		if (isNil(announcement)) return;

		sendAnnouncementDisplayEvent(announcement);
		dialogContext?.openModal(ModalId.Announcement, {
			dialogContent: announcement,
			onClose: async closeModal => {
				await announcementManager.markAsViewed(announcement.documentId);
				closeModal();
			},
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [announcement, user?.hasAgreedToLegalDocuments]);

	return null;
};
